function BackgroundController(){
    this.className			= "BackgroundController";
    this.debug				= false;
    this.glob				= "/**";
    this.debugging 			= false;
};
BackgroundController.inheritsFrom( StandardController );
BackgroundController.prototype.swap = function( onComplete ){
    if(!this.isSetup) {
        this.setup();
    }

    this.setupSections(onComplete);

    return false;
}
BackgroundController.prototype.setup = function( onComplete ){
    this.isSetup = true;

    // Elements
    this.$body 	  = $("body");
    // Theme background is painted on html (see _transition.scss); sync classes here too.
    this.$html    = $("html");
    this.$html.addClass("transition-colors");
    this.currentTheme = false;
    // this.$header  = this.$body.find('.js-site-header');

    //gsap.registerPlugin(ScrollTrigger);
    //this.timeline = gsap.timeline();
}
BackgroundController.prototype.setupSections = function(onComplete) {
    this.$main 	  = this.$body.find("main");
    this.$section = this.$main.find('header, section');

    const sections = [];
    this.$section.each((i, section) => {
        const s = {};
        s.element = section;
        s.$section = $(section);

        s.ready = false;
        s.theme = s.$section.attr("data-theme"); //matches ? matches[1] : "bg-red";
        s.id = s.$section.attr("id");

        sections.push(s);
    });

    this.sections = sections;

    this.originalTheme = this.$body.attr('class').match(/\btheme--[a-z]+/)?.[0] || '';
    this.currentTheme = this.originalTheme;
    // Match the incoming page theme on both elements, clearing any theme left by the previous page.
    for (let i = 0; i < 2; i++) {
        const $el = i === 0 ? this.$body : this.$html;
        $el.removeClass((index, className) => (className.match(/\btheme\-\-[a-z]+/)||[])[0])
            .addClass(this.originalTheme);
    }
    console.log(this.originalTheme);

    this.scrollTriggers = [];

    /*
    this.sections.forEach((s, i) => {
        if(!s.theme) {
            s.ready = true;
            return;
        }

        //console.log(s);

        let startPosition = i === 0 ? `top` : "top";
        let endPosition = i === 0 ? `bottom` : "bottom";

        let startTrigger = i === 0 ? `top` : "top";
        let endTrigger = i === 0 ? `top` : "top";

        startPosition = "top-=400";
        endPosition = "bottom-=400";

        if(i === 0) startPosition = "top";

        const scrollTrigger = ScrollTrigger.create({
            trigger: s.element,
            markers: false,
            // start: `${startPosition} ${triggerPosition}`,
            // end: "bottom top",
            start: `${startPosition} ${startTrigger}`,  // When the top of the section hits the top of the viewport
            end: `${endPosition} ${endTrigger}`, // When the bottom of the section leaves the top of the viewport
            scrub: false,
            invalidateOnRefresh: true,
            immediateRender: false,
            onEnter: () => this.setTheme(s.theme, false),
            onEnterBack: () => this.setTheme(s.theme, false),
            onRefresh: () => {
                s.ready = true;
                this.isReadyCheck(onComplete);
                console.log("Refreshed!");
            }
        });

        this.scrollTriggers.push(scrollTrigger);
    });

    this.isReadyCheck(onComplete);
    */

    this.measureSections();
    this.checkScroll(true);

    this.resizeDelegate = jstage.addListener("resize",Igloo.delegate(this,this.onResize));
    this.scrollDelegate = jstage.addListener("scroll",Igloo.delegate(this,this.checkScroll));

    onComplete();
}
BackgroundController.prototype.measureSections = function(instant) {
    for (let i = 0; i < this.sections.length; i++) {
        const section = this.sections[i];
        const $section = section.$section;
        section.position = $section.position();
        section.top = section.position.top;
    }
}
BackgroundController.prototype.checkScroll = function(instant) {
    instant = instant === true;

    const s = jstage.getScroll();
    const h = jstage.getHeight();
    const headerOffset = this.$body.find('.js-site-header').outerHeight() || 0;
    const triggerOffset = Math.max(headerOffset, h * 0.60);
    let currentSection = false;
    for (let i = 0; i < this.sections.length; i++) {
        const section = this.sections[i];
        if(section.top - triggerOffset <= s){
            currentSection = section;
        }
    }
    if(!currentSection) currentSection = this.sections[0];

    if(currentSection) {
        const currentTheme = currentSection.theme;
        this.setTheme(currentTheme, instant);
    }
}
BackgroundController.prototype.onResize = function(){
    this.measureSections();
    this.checkScroll();
};
BackgroundController.prototype.on = function(onComplete) {
   //this.checkScroll();
}
BackgroundController.prototype.setTheme = function(theme = false, instant = true) {
    if(theme === this.currentTheme) return;

    if(this.transitionTimeout) {
        clearTimeout(this.transitionTimeout);
        this.transitionTimeout = false;
    }

    console.log("Setting theme!", theme, instant);

    const transitionClass = instant ? 'instant' : 'transitioning';
    this.$body.addClass(transitionClass);
    this.$html.addClass(transitionClass);

    /*
    if(instant) {
        debugger;
    }
    */

    const themeClass = !theme ? this.originalTheme : "theme--"+theme;
    this.currentTheme = !theme ? this.originalTheme : theme;

    // body: text colour. html: background colour (inherited by fixed ::before in _transition.scss).
    this.$body
        .removeClass((index, className) => (className.match(/\btheme\-\-[a-z]+/)||[])[0])
        .addClass(themeClass);
    this.$html
        .removeClass((index, className) => (className.match(/\btheme\-\-[a-z]+/)||[])[0])
        .addClass(themeClass);

    // debugger;

    if(instant) {
        setTimeout(() => {
            this.$body.removeClass('instant');
            this.$html.removeClass('instant');
        }, 1);
    } else {
        this.transitionTimeout = setTimeout(() => {
            this.$body.removeClass('transitioning');
            this.$html.removeClass('transitioning');
        }, 700);
    }
}
BackgroundController.prototype.isReadyCheck = function(onComplete) {
    let isReady = true;

    this.sections.forEach((s, i) => {
        if(!s.ready) isReady = false;
    });

    if(isReady) onComplete();
}
BackgroundController.prototype.killScrollTriggers = function(){
    if(this.scrollTriggers.length === 0) return;
    this.scrollTriggers.forEach(scrollTrigger => scrollTrigger.kill());
    this.scrollTriggers = []; // Reset the array
}
BackgroundController.prototype.off = function(){
    if(this.scrollDelegate) jstage.removeListener("scroll",this.scrollDelegate);
    if(this.resizeDelegate) jstage.removeListener("resize",this.resizeDelegate);

    this.killScrollTriggers();

    if(this.transitionTimeout) {
        clearTimeout(this.transitionTimeout);
        this.transitionTimeout = false;
    }

    this.$body.addClass('instant').removeClass('transitioning');
    this.$html.addClass('instant').removeClass('transitioning');
    // this.$body.removeClass((index, className) => (className.match(/\btheme\-\-[a-z]+/)||[])[0])

    // return true;
};
